import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, of, ReplaySubject, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceResult } from '../../base-classes/service-result';


@Injectable()
export class MyHttpService {

    constructor(private http: HttpClient) { }


    doHttp<T, R>(url: string, mapFn: (x: T) => R): Observable<ServiceResult<R>> {
        let useOnceReplaySubject = new ReplaySubject<ServiceResult<R>>(1)
        //Note, complete and next will never be called in this case
        //Can we do anything with unsub?  Probably not
        let unsub = this.doHttpGetAndNotifyObserver<T, R>(url, { next: x => useOnceReplaySubject.next(x), error: null, complete: null }, mapFn)

        return useOnceReplaySubject.asObservable();
    }

    doHttpGetAndNotifyObserver<T, R>(url: string, observer: Observer<ServiceResult<R>>, mapFn: (x: T) => R): Subscription {

        let isMapError: boolean = false;

        let unsub = this.http.get<T>(url).pipe(
            map(val => {
                try { return mapFn(val); } catch (err) { isMapError = true; throw err; }
            }
            ))
            .subscribe(
                val => { observer.next(ServiceResult.successResult(val)); },
                err => { observer.next(<ServiceResult<R>>(isMapError ? ServiceResult.fromAppError(err) : ServiceResult.fromHttpError(err))); }
            );


        return unsub;
    }


    //Results will be chagned to ServiceResult if there is an error
    doHttpSafePost<T, R>(url: string, postValue: any, mapFn: (x: T) => R): Observable<ServiceResult<R>> {
        return this.http.post<T>(url, postValue).pipe(
            map(x => mapFn(x)),
            map(x => ServiceResult.successResult(x)),
            catchError(err => of(ServiceResult.fromHttpError<R>(err))));
    }
    doHttpSafeDelete<T, R>(url: string, mapFn: (x: T) => R): Observable<ServiceResult<R>> {
        return this.http.delete<T>(url).pipe(
            map(x => mapFn(x)),
            map(x => ServiceResult.successResult(x)),
            catchError(err => of(ServiceResult.fromHttpError<R>(err))));
    }

}
